import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Ct2ConfigService } from '../ct2-config.service';
import { WordRect } from '@ps-gui/claims-terminal-shared';
import { ApiService } from '@ps-gui/shared-core';

@Injectable({
  providedIn: 'root',
})
export class TableDetectionApiService extends ApiService {
  private readonly configService = inject(Ct2ConfigService);

  protected override get baseUrl(): string {
    return this.configService.config.tableDetectionUrl;
  }

  /**
   * Returns an array of columns. Each column is an array of indices
   * from the input array of elements belonging together.
   * The columns are ordered from left to right.
   *
   * @param wordRects all words from the ocr representing a table
   */
  detectTable(wordRects: WordRect[]): Observable<number[][]> {
    // TODO: 0.01 is an 'sometimes-okay'-threshold, but we should let the user influence that somehow
    return this.post('detect-table', { distanceThreshold: 0.01, wordRects });
  }
}
